import { setUserActionPayload, setIsCartUpdated, addUpdateCartItem } from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";

interface UpdateCartItemPayload {
  itemUpdates: CartItem;
  cartItems: CartItem[];
  currentPatientId: string;
  dispatch: any;
  quantity?: number;
}

export const updateCartItem = ({
  itemUpdates,
  cartItems,
  currentPatientId,
  dispatch,
  quantity,
}: UpdateCartItemPayload) => {
  const foundIndex = cartItems.findIndex((item) => item.sku == itemUpdates.sku);

  if (foundIndex >= 0) {
    const modifiedQty = quantity ? quantity : (itemUpdates.quantity += cartItems[foundIndex].quantity);

    if (cartItems && modifiedQty) {
      //  itemUpdates.quantity += cartItems[foundIndex].quantity;
      if (currentPatientId) {
        dispatch(
          setUserActionPayload({
            medicineOrderCartLineItems: [
              {
                medicineSKU: cartItems[foundIndex].sku,
                quantity: modifiedQty,
              },
            ],
          })
        );
      } else {
        dispatch(addUpdateCartItem(itemUpdates));
        dispatch(setIsCartUpdated(true));
      }
    }
  }
};
